// 会员
export const MC_DISCOUNT_TYPE = { // 会员卡优惠类型
  RATE: 'discountRate',
  PRICE: 'memberPrice'
}
